/**
 * SVG icon for health aspect
 */
import classnames from 'classnames';
import React, { PropTypes } from 'react';

function SymbolHealthBig({ animating, hoveredAspect }) {
  return (
    <symbol
      className="wheel-icon"
      id="icon-health"
      viewBox="0 0 134.5 137.3"
    >
      <g>
        <line
          className="st0"
          x1="134.5"
          y1="2"
          x2="131.7"
          y2="0"
        />
        <g>
          <path
            className={classnames({
              'is-hovered': hoveredAspect === 'tid:59',
              st0: true,
            })}
            d="M82.3,68.1c0-6.8-4.4-12.5-10.5-14.6c-0.9-0.1-12.5-1.6-13.2,12.8C57.9,80.9,70,82.8,70.8,82.9 C77.4,81.2,82.3,75.2,82.3,68.1z"
          />
          <path
            className={classnames({
              'is-hovered': hoveredAspect === 'tid:59',
              st1: true,
            })}
            d="M58.6,66.4c0.7-14.5,12.3-13,13.2-12.8c-1.5-0.5-3.2-0.8-4.8-0.8c-8.5,0-15.3,6.9-15.3,15.3c0,8.5,6.9,15.3,15.3,15.3c1.3,0,2.6-0.2,3.9-0.5C70,82.8,57.9,80.9,58.6,66.4z"
          />
        </g>
        <g>
          <path
            className={classnames({
              'is-hovered': hoveredAspect === 'tid:59',
              st0: true,
            })}
            d="M59.3,10c0.3,5,0.9,23.1,1.2,25.8c0.1,1.2,0,5.2,4.7,5.5c2.5-0.9,4.3-3.1,4.1-5.7l-1-25.2c-0.1-2.5-1.9-4.6-4.3-5.3C63.5,5,59.1,5.3,59.3,10z"
          />
          <path
            className={classnames({
              'is-hovered': hoveredAspect === 'tid:59',
              st1: true,
            })}
            d="M55.6,10.8l1,25.2c0.1,1.4,0.7,2.7,1.6,3.7c1.2,1.2,3,2,5,1.9c0.7,0,1.3-0.2,2-0.4c-4.6-0.3-4.5-4.3-4.7-5.5c-0.3-2.7-0.9-20.8-1.2-25.8C59.1,5.3,63.5,5,63.9,5c-0.7-0.2-1.5-0.3-2.3-0.3C58.2,4.8,55.4,7.6,55.6,10.8z"
          />
        </g>
        <g>
          <path
            className={classnames({
              'is-hovered': hoveredAspect === 'tid:59',
              st0: true,
            })}
            d="M104.9,20.5c-3.2,3.8-15.1,17.5-16.7,19.7c-0.7,1-3.5,3.8-0.3,7.2c2.4,1.1,5.3,0.7,7-1.3L111.3,27c1.6-1.9,1.7-4.6,0.4-6.9C111.3,19.8,107.9,16.9,104.9,20.5z"
          />
          <path
            className={classnames({
              'is-hovered': hoveredAspect === 'tid:59',
              st1: true,
            })}
            d="M101.5,18.5L85.2,37.7c-0.9,1.1-1.3,2.4-1.3,3.8c0.1,1.8,0.9,3.6,2.4,4.9c0.5,0.5,1.1,0.8,1.7,1.1c-3.3-3.4-0.5-6.3,0.3-7.2c1.6-2.1,13.5-15.8,16.7-19.7c3-3.6,6.4-0.7,6.8-0.4c-0.4-0.7-0.9-1.3-1.5-1.8C107.5,16,103.6,16.1,101.5,18.5z"
          />
        </g>
        <g>
          <path
            className={classnames({
              'is-hovered': hoveredAspect === 'tid:59',
              st0: true,
            })}
            d="M125.3,63.1c-4.9,0.4-23.1,1.8-25.7,2.1c-1.2,0.2-5.2,0.2-5.3,4.9c0.9,2.5,3.2,4.1,5.8,3.9l25.1-2
            c2.5-0.2,4.5-2.1,5.1-4.5C130.3,67,130,62.6,125.3,63.1z"
          />
          <path
            className={classnames({
              'is-hovered': hoveredAspect === 'tid:59',
              st1: true,
            })}
            d="M124.3,59.3l-25.1,2c-1.4,0.1-2.7,0.8-3.6,1.8c-1.2,1.3-1.9,3.1-1.8,5c0.1,0.7,0.2,1.3,0.5,1.9c0.1-4.6,4.1-4.7,5.3-4.9c2.6-0.4,20.7-1.7,25.7-2.1c4.7-0.4,5.1,4,5.1,4.4c0.2-0.7,0.3-1.5,0.2-2.3C130.3,61.7,127.5,59.1,124.3,59.3z"
          />
        </g>
        <g>
          <path
            className={classnames({
              'is-hovered': hoveredAspect === 'tid:59',
              st0: true,
            })}
            d="M88.8,92.5c3.9,3.1,17.8,14.8,19.9,16.4c1,0.7,3.9,3.5,7.2,0.2c1-2.4,0.5-5.2-1.5-6.9L95,86.1c-1.9-1.6-4.6-1.6-6.8-0.4C87.9,86.1,85.1,89.5,88.8,92.5z"
          />
          <path
            className={classnames({
              'is-hovered': hoveredAspect === 'tid:59',
              st1: true,
            })}
            d="M86.9,95.8l19.4,16.1c1.1,0.9,2.4,1.3,3.8,1.3c1.7-0.1,3.5-0.9,4.8-2.4c0.4-0.5,0.8-1.1,1-1.7c-3.3,3.2-6.2,0.5-7.2-0.2c-2.2-1.6-16-13.2-19.9-16.4c-3.7-3-0.9-6.4-0.6-6.7c-0.6,0.4-1.2,0.9-1.7,1.5C84.2,89.9,84.4,93.7,86.9,95.8z"
          />
        </g>
        <g>
          <path
            className={classnames({
              'is-hovered': hoveredAspect === 'tid:59',
              st0: true,
            })}
            d="M18.4,33.2c3.9,3.1,17.8,14.7,20,16.3c1,0.7,3.9,3.4,7.2,0.2c1-2.4,0.5-5.2-1.5-6.9l-19.5-16 c-1.9-1.6-4.7-1.6-6.8-0.3C17.5,26.9,14.8,30.3,18.4,33.2z"
          />
          <path
            className={classnames({
              'is-hovered': hoveredAspect === 'tid:59',
              st1: true,
            })}
            d="M16.5,36.6l19.5,16c1.1,0.9,2.5,1.3,3.8,1.2c1.7-0.1,3.5-0.9,4.8-2.4c0.4-0.5,0.8-1.1,1-1.7 c-3.3,3.3-6.2,0.5-7.2-0.2c-2.2-1.6-16.1-13.2-20-16.3c-3.7-3-0.9-6.4-0.6-6.7c-0.6,0.4-1.2,0.9-1.7,1.5 C13.8,30.7,14,34.5,16.5,36.6z"
          />
        </g>
        <g>
          <path
            className={classnames({
              'is-hovered': hoveredAspect === 'tid:59',
              st0: true,
            })}
            d="M34.5,70.8c-5,0.4-23.1,1.6-25.7,2c-1.2,0.2-5.2,0.2-5.3,4.8c0.9,2.4,3.2,4.1,5.8,3.9l25.1-1.8 c2.5-0.2,4.5-2,5.2-4.4C39.5,74.8,39.2,70.4,34.5,70.8z"
          />
          <path
            className={classnames({
              'is-hovered': hoveredAspect === 'tid:59',
              st1: true,
            })}
            d="M33.6,67.1L8.4,68.9C7,69,5.8,69.7,4.8,70.6c-1.2,1.2-1.9,3-1.8,5c0,0.7,0.2,1.3,0.4,1.9 c0.1-4.6,4.1-4.6,5.3-4.8c2.6-0.4,20.8-1.5,25.7-2c4.7-0.4,5,4,5.1,4.4c0.2-0.7,0.3-1.5,0.2-2.2C39.6,69.5,36.8,66.9,33.6,67.1z"
          />
        </g>
        <g>
          <path
            className={classnames({
              'is-hovered': hoveredAspect === 'tid:59',
              st0: true,
            })}
            d="M45.8,91.4C42.3,95,29.6,108,27.8,110c-0.8,0.9-3.8,3.6-0.8,7.1c2.3,1.2,5.2,1,7-0.9l17.6-18.1 c1.7-1.8,2-4.5,0.9-6.8C52.2,91.1,49,88,45.8,91.4z"
          />
          <path
            className={classnames({
              'is-hovered': hoveredAspect === 'tid:59',
              st1: true,
            })}
            d="M42.6,89.3L25,107.3c-1,1-1.5,2.3-1.6,3.7c-0.1,1.7,0.6,3.6,2,4.9c0.5,0.5,1,0.8,1.6,1.1c-3-3.5,0-6.2,0.8-7.1 c1.7-2,14.5-14.9,17.9-18.5c3.3-3.4,6.4-0.4,6.7-0.1c-0.3-0.7-0.8-1.3-1.3-1.9C48.7,87.1,44.8,87,42.6,89.3z"
          />
        </g>
        <g>
          <path
            className={classnames({
              'is-hovered': hoveredAspect === 'tid:59',
              st0: true,
            })}
            d="M66.7,99.9c0.6,4.9,2.3,23,2.8,25.6c0.2,1.2,0.4,5.2,4.9,5.2c2.4-1,4-3.4,3.7-5.9l-2.6-25 c-0.3-2.5-2.2-4.4-4.6-5C70.5,94.8,66.1,95.3,66.7,99.9z"
          />
          <path
            className={classnames({
              'is-hovered': hoveredAspect === 'tid:59',
              st1: true,
            })}
            d="M63,101l2.6,25c0.1,1.4,0.8,2.7,1.8,3.6c1.3,1.2,3.1,1.8,5,1.6c0.7-0.1,1.3-0.3,1.9-0.5c-4.6,0-4.7-4-4.9-5.2 c-0.4-2.6-2.2-20.7-2.8-25.6c-0.5-4.7,3.8-5.2,4.2-5.2c-0.7-0.2-1.5-0.3-2.3-0.2C65.2,94.9,62.7,97.8,63,101z"
          />
        </g>
      </g>
    </symbol>
  );
}

SymbolHealthBig.propTypes = {
  hoveredAspect: PropTypes.string,
};

export default SymbolHealthBig;



// WEBPACK FOOTER //
// js/src/wheel/symbols/SymbolHealthBig.js